import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OrderReportsEffects } from './effects/admin-order-reports.effects';
import { analyticsReducer } from './reducer/analytics.reducer';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('analytics', analyticsReducer),
        EffectsModule.forFeature([OrderReportsEffects]),
    ],
})
export class AnalyticsModule {}
